var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPentagonEnergy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 135,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.27 67.5l-37.888 66H39.618L1.73 67.5l37.889-66h75.763l37.888 66z",
    stroke: "#E0621E",
    strokeWidth: 3
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTU1IiBoZWlnaHQ9IjEzNSIgdmlld0JveD0iMCAwIDE1NSAxMzUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTUzLjI3IDY3LjVMMTE1LjM4MiAxMzMuNUgzOS42MTg1TDEuNzI5NiA2Ny41TDM5LjYxODUgMS41SDExNS4zODJMMTUzLjI3IDY3LjVaIiBzdHJva2U9IiNFMDYyMUUiIHN0cm9rZS13aWR0aD0iMyIvPgo8L3N2Zz4K";
export { SvgPentagonEnergy as ReactComponent };